function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M346.68,222.2H53.32a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H346.68a.5.5,0,0,1,.5.5A.5.5,0,0,1,346.68,222.2Z",
  fill: "#d1d3d4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 242.41,
  y: 62.12,
  width: 70.45,
  height: 155.71,
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M312.86,218.35H242.41a.51.51,0,0,1-.52-.51V62.12a.51.51,0,0,1,.52-.51h70.45a.51.51,0,0,1,.52.51V217.84A.51.51,0,0,1,312.86,218.35Zm-69.93-1h69.41V62.64H242.93Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 58.79,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,82.43H242.43a6.13,6.13,0,0,1-6.12-6.13V64.4a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,64.4V76.3A6.13,6.13,0,0,1,312.84,82.43ZM242.43,59.3a5.1,5.1,0,0,0-5.09,5.1V76.3a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V64.4a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,72.85a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,72.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,68.85Z",
  fill: "#d1d3d4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,72.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,72.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,68.85Z",
  fill: "#d1d3d4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,72h-48.5a.5.5,0,0,1-.5-.5V69.17a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5v2.36A.5.5,0,0,1,310.79,72Zm-48-1h47.5V69.67h-47.5Z",
  fill: "#d1d3d4"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 87.29,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,110.93H242.43a6.13,6.13,0,0,1-6.12-6.13V92.9a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,92.9v11.9A6.13,6.13,0,0,1,312.84,110.93ZM242.43,87.8a5.1,5.1,0,0,0-5.09,5.1v11.9a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V92.9a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,101.35a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,101.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,97.35Z",
  fill: "#d1d3d4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,101.35a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,101.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,97.35Z",
  fill: "#d1d3d4"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,100.53h-48.5a.5.5,0,0,1-.5-.5V97.67a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5V100A.5.5,0,0,1,310.79,100.53Zm-48-1h47.5V98.17h-47.5Z",
  fill: "#d1d3d4"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 115.79,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,139.43H242.43a6.13,6.13,0,0,1-6.12-6.13V121.4a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,121.4v11.9A6.13,6.13,0,0,1,312.84,139.43ZM242.43,116.3a5.1,5.1,0,0,0-5.09,5.1v11.9a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V121.4a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,129.85a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,129.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,125.85Z",
  fill: "#d1d3d4"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,129.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,129.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,125.85Z",
  fill: "#d1d3d4"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,129h-48.5a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5v2.36A.5.5,0,0,1,310.79,129Zm-48-1h47.5v-1.36h-47.5Z",
  fill: "#d1d3d4"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 144.28,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,167.93H242.43a6.13,6.13,0,0,1-6.12-6.13V149.9a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,149.9v11.9A6.13,6.13,0,0,1,312.84,167.93ZM242.43,144.8a5.1,5.1,0,0,0-5.09,5.1v11.9a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V149.9a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,158.35a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,158.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,154.35Z",
  fill: "#d1d3d4"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,158.35a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,158.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,154.35Z",
  fill: "#d1d3d4"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,157.53h-48.5a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5V157A.5.5,0,0,1,310.79,157.53Zm-48-1h47.5v-1.36h-47.5Z",
  fill: "#d1d3d4"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 172.78,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,196.43H242.43a6.13,6.13,0,0,1-6.12-6.13V178.4a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,178.4v11.9A6.13,6.13,0,0,1,312.84,196.43ZM242.43,173.3a5.1,5.1,0,0,0-5.09,5.1v11.9a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V178.4a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,186.85a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,186.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,182.85Z",
  fill: "#d1d3d4"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,186.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,186.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,182.85Z",
  fill: "#d1d3d4"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,186h-48.5a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5v2.36A.5.5,0,0,1,310.79,186Zm-48-1h47.5v-1.36h-47.5Z",
  fill: "#d1d3d4"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 236.82,
  y: 201.28,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M312.84,224.93H242.43a6.13,6.13,0,0,1-6.12-6.13V206.9a6.13,6.13,0,0,1,6.12-6.13h70.41A6.13,6.13,0,0,1,319,206.9v11.9A6.13,6.13,0,0,1,312.84,224.93ZM242.43,201.8a5.1,5.1,0,0,0-5.09,5.1v11.9a5.1,5.1,0,0,0,5.09,5.1h70.41a5.1,5.1,0,0,0,5.09-5.1V206.9a5.1,5.1,0,0,0-5.09-5.1Z",
  fill: "#231f20"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M246.48,215.35a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,246.48,215.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,246.48,211.35Z",
  fill: "#d1d3d4"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M254.92,215.35a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,254.92,215.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,254.92,211.35Z",
  fill: "#d1d3d4"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M310.79,214.53h-48.5a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5V214A.5.5,0,0,1,310.79,214.53Zm-48-1h47.5v-1.36h-47.5Z",
  fill: "#d1d3d4"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 244.9,
  y: 224.41,
  width: 8.45,
  height: 3.44,
  fill: "#231f20"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M253.35,228.37H244.9a.51.51,0,0,1-.51-.51v-3.45a.51.51,0,0,1,.51-.51h8.45a.51.51,0,0,1,.51.51v3.45A.51.51,0,0,1,253.35,228.37Zm-7.93-1h7.41v-2.41h-7.41Z",
  fill: "#231f20"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 301.92,
  y: 224.41,
  width: 8.45,
  height: 3.44,
  fill: "#231f20"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M310.37,228.37h-8.45a.51.51,0,0,1-.51-.51v-3.45a.51.51,0,0,1,.51-.51h8.45a.51.51,0,0,1,.51.51v3.45A.51.51,0,0,1,310.37,228.37Zm-7.93-1h7.41v-2.41h-7.41Z",
  fill: "#231f20"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 148.25,
  y: 121.27,
  width: 70.45,
  height: 96.57,
  fill: "#231f20"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M218.7,218.35H148.25a.51.51,0,0,1-.51-.51V121.27a.51.51,0,0,1,.51-.52H218.7a.52.52,0,0,1,.52.52v96.57A.51.51,0,0,1,218.7,218.35Zm-69.93-1h69.42V121.79H148.77Z",
  fill: "#231f20"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 142.66,
  y: 115.79,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M218.68,139.43h-70.4a6.14,6.14,0,0,1-6.13-6.13V121.4a6.14,6.14,0,0,1,6.13-6.13h70.4a6.14,6.14,0,0,1,6.13,6.13v11.9A6.14,6.14,0,0,1,218.68,139.43Zm-70.4-23.13a5.11,5.11,0,0,0-5.1,5.1v11.9a5.11,5.11,0,0,0,5.1,5.1h70.4a5.11,5.11,0,0,0,5.1-5.1V121.4a5.11,5.11,0,0,0-5.1-5.1Z",
  fill: "#231f20"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M152.32,129.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,152.32,129.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,152.32,125.85Z",
  fill: "#d1d3d4"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M160.77,129.85a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,160.77,129.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,160.77,125.85Z",
  fill: "#d1d3d4"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M216.64,129H168.13a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.51a.5.5,0,0,1,.5.5v2.36A.51.51,0,0,1,216.64,129Zm-48-1h47.51v-1.36H168.63Z",
  fill: "#d1d3d4"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 142.66,
  y: 144.28,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M218.68,167.93h-70.4a6.14,6.14,0,0,1-6.13-6.13V149.9a6.14,6.14,0,0,1,6.13-6.13h70.4a6.14,6.14,0,0,1,6.13,6.13v11.9A6.14,6.14,0,0,1,218.68,167.93Zm-70.4-23.13a5.11,5.11,0,0,0-5.1,5.1v11.9a5.11,5.11,0,0,0,5.1,5.1h70.4a5.11,5.11,0,0,0,5.1-5.1V149.9a5.11,5.11,0,0,0-5.1-5.1Z",
  fill: "#231f20"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M152.32,158.35a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,152.32,158.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,152.32,154.35Z",
  fill: "#d1d3d4"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M160.77,158.35a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,160.77,158.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,160.77,154.35Z",
  fill: "#d1d3d4"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M216.64,157.53H168.13a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.51a.5.5,0,0,1,.5.5V157A.51.51,0,0,1,216.64,157.53Zm-48-1h47.51v-1.36H168.63Z",
  fill: "#d1d3d4"
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 142.66,
  y: 172.78,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M218.68,196.43h-70.4a6.14,6.14,0,0,1-6.13-6.13V178.4a6.14,6.14,0,0,1,6.13-6.13h70.4a6.14,6.14,0,0,1,6.13,6.13v11.9A6.14,6.14,0,0,1,218.68,196.43Zm-70.4-23.13a5.11,5.11,0,0,0-5.1,5.1v11.9a5.11,5.11,0,0,0,5.1,5.1h70.4a5.11,5.11,0,0,0,5.1-5.1V178.4a5.11,5.11,0,0,0-5.1-5.1Z",
  fill: "#231f20"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M152.32,186.85a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,152.32,186.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,152.32,182.85Z",
  fill: "#d1d3d4"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M160.77,186.85a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,160.77,186.85Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,160.77,182.85Z",
  fill: "#d1d3d4"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M216.64,186H168.13a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.51a.5.5,0,0,1,.5.5v2.36A.51.51,0,0,1,216.64,186Zm-48-1h47.51v-1.36H168.63Z",
  fill: "#d1d3d4"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 142.66,
  y: 201.28,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M218.68,224.93h-70.4a6.14,6.14,0,0,1-6.13-6.13V206.9a6.14,6.14,0,0,1,6.13-6.13h70.4a6.14,6.14,0,0,1,6.13,6.13v11.9A6.14,6.14,0,0,1,218.68,224.93Zm-70.4-23.13a5.11,5.11,0,0,0-5.1,5.1v11.9a5.11,5.11,0,0,0,5.1,5.1h70.4a5.11,5.11,0,0,0,5.1-5.1V206.9a5.11,5.11,0,0,0-5.1-5.1Z",
  fill: "#231f20"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M152.32,215.35a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,152.32,215.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,152.32,211.35Z",
  fill: "#d1d3d4"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M160.77,215.35a2.5,2.5,0,1,1,2.5-2.5A2.51,2.51,0,0,1,160.77,215.35Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.51,1.51,0,0,0,160.77,211.35Z",
  fill: "#d1d3d4"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M216.64,214.53H168.13a.5.5,0,0,1-.5-.5v-2.36a.5.5,0,0,1,.5-.5h48.51a.5.5,0,0,1,.5.5V214A.51.51,0,0,1,216.64,214.53Zm-48-1h47.51v-1.36H168.63Z",
  fill: "#d1d3d4"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 150.74,
  y: 224.41,
  width: 8.45,
  height: 3.44,
  fill: "#231f20"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M159.19,228.37h-8.45a.51.51,0,0,1-.51-.51v-3.45a.51.51,0,0,1,.51-.51h8.45a.51.51,0,0,1,.52.51v3.45A.51.51,0,0,1,159.19,228.37Zm-7.93-1h7.42v-2.41h-7.42Z",
  fill: "#231f20"
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 207.76,
  y: 224.41,
  width: 8.45,
  height: 3.44,
  fill: "#231f20"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M216.21,228.37h-8.45a.51.51,0,0,1-.51-.51v-3.45a.51.51,0,0,1,.51-.51h8.45a.51.51,0,0,1,.52.51v3.45A.51.51,0,0,1,216.21,228.37Zm-7.93-1h7.42v-2.41h-7.42Z",
  fill: "#231f20"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M340.94,201.47H328.17a.51.51,0,0,1-.5-.5V190.83a.5.5,0,0,1,.5-.5h12.77a.5.5,0,0,1,.5.5V201A.5.5,0,0,1,340.94,201.47Zm-12.27-1h11.77v-9.14H328.67Z",
  fill: "#d1d3d4"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M334.56,199.08a3.19,3.19,0,1,1,3.18-3.18A3.18,3.18,0,0,1,334.56,199.08Zm0-5.37a2.19,2.19,0,1,0,2.18,2.19A2.19,2.19,0,0,0,334.56,193.71Z",
  fill: "#d1d3d4"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M105,65.93A4.1,4.1,0,0,0,103,64.34a1.64,1.64,0,0,0-2.08.94c-2-3.12-6.34-3.82-10-3.15-6.1,1.13-10.37,3.49-12.11,9.78-.65,2.37-.78,4.88-1.62,7.19a29.86,29.86,0,0,1-3.62,6.22,1.2,1.2,0,0,0-.28.75,1.14,1.14,0,0,0,.43.69,8.12,8.12,0,0,0,3.12,2.14,3.52,3.52,0,0,0,3.56-.64,2.18,2.18,0,0,0,0,2.71,4.89,4.89,0,0,0,2.46,1.54c6.11,2,13.68-.08,18.47-4.17a20.47,20.47,0,0,0,6.4-10.27C109,73.49,107.88,69.73,105,65.93Z",
  fill: "#fff"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M88,93.79a16.52,16.52,0,0,1-5.21-.8,5.44,5.44,0,0,1-2.7-1.72,3,3,0,0,1-.6-1.86,4.45,4.45,0,0,1-2.77,0,8.74,8.74,0,0,1-3.31-2.26,1.66,1.66,0,0,1-.58-1,1.71,1.71,0,0,1,.36-1.07l.64-.94a24.36,24.36,0,0,0,2.93-5.18,24.23,24.23,0,0,0,1-4c.18-1,.37-2.08.65-3.11,2-7.27,7.45-9.21,12.5-10.14,3.22-.6,7.65-.2,10,2.74a2.29,2.29,0,0,1,.43-.32,2.39,2.39,0,0,1,1.83-.2,4.59,4.59,0,0,1,2.2,1.76c3.23,4.21,4.14,8.09,3,12.58a21.08,21.08,0,0,1-6.56,10.52A21.76,21.76,0,0,1,88,93.79Zm-7.56-6a.52.52,0,0,1,.35.14.51.51,0,0,1,0,.7,1.7,1.7,0,0,0,.08,2.07A4.53,4.53,0,0,0,83.1,92c5.59,1.87,13,.19,18-4.08a20.07,20.07,0,0,0,6.25-10c1.11-4.16.25-7.77-2.77-11.71h0a3.71,3.71,0,0,0-1.69-1.41,1.44,1.44,0,0,0-1.06.11.79.79,0,0,0-.4.48.52.52,0,0,1-.41.37.49.49,0,0,1-.49-.23c-2-3.09-6.33-3.51-9.47-2.93-6.82,1.26-10.21,4-11.72,9.43-.27,1-.45,2-.63,3a24.17,24.17,0,0,1-1,4.2,25.09,25.09,0,0,1-3,5.4L74,85.6c-.07.12-.21.32-.19.42s.18.29.28.39a8.06,8.06,0,0,0,2.92,2,3.1,3.1,0,0,0,3.06-.52A.49.49,0,0,1,80.43,87.76Z",
  fill: "#231f20"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M104.69,77.71s3.61,5.19,2.92,6.3-3.11.45-3.11.45",
  fill: "#fff"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M106,85.16a6.59,6.59,0,0,1-1.61-.22.5.5,0,0,1,.27-1c.67.18,2.18.37,2.56-.23s-1.13-3.19-2.91-5.75a.5.5,0,0,1,.12-.7.51.51,0,0,1,.7.12c1.14,1.65,3.72,5.6,2.93,6.86A2.3,2.3,0,0,1,106,85.16Z",
  fill: "#231f20"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M103.77,70.75c2.27,1.76,1.72,5.61,1.76,8.1.06,3.51,0,7-.07,10.52-.06,2.23-5.82,2.41-6.85,1.77l1.12,8.76s-2.75.83-7.44-1.21-4.77-3.13-4.77-3.13l.14-10.15s3.8-.06,5.94-4.64,1.87-11.54,1.87-11.54S101.56,69,103.77,70.75Z",
  fill: "#fff"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M98.15,100.57a15.43,15.43,0,0,1-6.06-1.42c-4.49-2-5-3.14-5.06-3.56l.13-10.18a.51.51,0,0,1,.49-.5c.14,0,3.53-.13,5.5-4.35C95.21,76.13,95,69.31,95,69.24a.54.54,0,0,1,.14-.36.51.51,0,0,1,.35-.15c.25,0,6.29-.18,8.62,1.63h0c2.08,1.61,2,4.68,2,7.14,0,.48,0,.93,0,1.34,0,3.51,0,7.06-.07,10.55a2.06,2.06,0,0,1-1.28,1.76,10,10,0,0,1-5.47.7l1,8a.5.5,0,0,1-.35.54A6.15,6.15,0,0,1,98.15,100.57ZM88,95.48c.09.18.76,1.14,4.46,2.75a12.83,12.83,0,0,0,6.68,1.27l-1-8.29a.49.49,0,0,1,.75-.49,8.47,8.47,0,0,0,5.33-.45c.5-.26.75-.57.76-.91.1-3.48.12-7,.07-10.5,0-.43,0-.89,0-1.38,0-2.24.11-5-1.58-6.33-1.54-1.21-5.54-1.44-7.48-1.43C96,71.43,95.9,77,94.05,81s-4.74,4.71-5.9,4.88Z",
  fill: "#231f20"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M105.31,86.76s-2.67,1.74-4.19-1",
  fill: "#fff"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M103.49,87.8a3.18,3.18,0,0,1-.74-.09A3.32,3.32,0,0,1,100.68,86a.5.5,0,0,1,.88-.48A2.37,2.37,0,0,0,103,86.74a3,3,0,0,0,2.05-.4.49.49,0,0,1,.69.15.5.5,0,0,1-.14.69A4.27,4.27,0,0,1,103.49,87.8Z",
  fill: "#231f20"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M98,80.12a4.85,4.85,0,0,0-1-2.38,7,7,0,0,0-1.31-1.56,2.26,2.26,0,0,0-1.9-.53,2.15,2.15,0,0,0-1.35,1.12,4,4,0,0,0-.4,1.75,7.56,7.56,0,0,0,3.63,6.59l-.19-.21",
  fill: "#fff"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M95.66,85.61a.59.59,0,0,1-.26-.07,8.08,8.08,0,0,1-3.88-7,4.53,4.53,0,0,1,.45-2,2.65,2.65,0,0,1,1.68-1.38,2.74,2.74,0,0,1,2.33.63,7.28,7.28,0,0,1,1.41,1.67,5.2,5.2,0,0,1,1.13,2.64.5.5,0,0,1-.48.52.52.52,0,0,1-.52-.48,4.36,4.36,0,0,0-1-2.12,6.27,6.27,0,0,0-1.2-1.45,1.79,1.79,0,0,0-1.48-.43,1.61,1.61,0,0,0-1,.86,3.51,3.51,0,0,0-.34,1.54,7.06,7.06,0,0,0,3,5.86.51.51,0,0,1,.33.15l.2.21a.49.49,0,0,1,0,.65A.5.5,0,0,1,95.66,85.61Z",
  fill: "#231f20"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M98.61,91.14a9.34,9.34,0,0,1-4.44-2.86s.33,5.33,4.94,6.76Z",
  fill: "#231f20"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M99.11,95.54a.39.39,0,0,1-.15,0c-4.89-1.52-5.28-7-5.29-7.21a.5.5,0,0,1,.9-.32,8.79,8.79,0,0,0,4.18,2.67.52.52,0,0,1,.36.42L99.6,95a.51.51,0,0,1-.17.45A.54.54,0,0,1,99.11,95.54ZM95,89.81a6.75,6.75,0,0,0,3.55,4.47l-.35-2.76A10.9,10.9,0,0,1,95,89.81Z",
  fill: "#231f20"
});

var _ref79 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.63,
  cy: 75.33,
  rx: 1.25,
  ry: 0.49,
  transform: "translate(13.42 166.16) rotate(-81.8)",
  fill: "#231f20"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M121.15,109c-2.38.92-3.62-.42-4.63-3.73a5,5,0,0,1-.16-1.81,18.28,18.28,0,0,1,.48-2.64,45.33,45.33,0,0,1,2.52-7.09c.25-.58.74-1.27,1.33-1.07s.59.84.58,1.37c0,1.5-.25,3-.21,4.51,3.16-.81,5.14-4.15,8.14-4.86.85-.21,1.89-.27,2,.83.11,1.35-2.34,2.41-3.15,3.12a9.82,9.82,0,0,1,3.09-1.81,2,2,0,0,1,1-.16.79.79,0,0,1,.68.68,1.07,1.07,0,0,1-.36.74,9.59,9.59,0,0,1-1.55,1.44,3.89,3.89,0,0,1,2.19-1.29,1.13,1.13,0,0,1,1.2.32c.35.58-.32,1.22-.91,1.55a3.47,3.47,0,0,1,1.64-.81,1.2,1.2,0,0,1,1.37.93,1.63,1.63,0,0,1-.65,1.22C132.64,103.49,125.15,107.44,121.15,109Z",
  fill: "#fff"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M119.82,109.77a2.71,2.71,0,0,1-1.2-.27c-1.08-.53-1.88-1.79-2.58-4.1a5.41,5.41,0,0,1-.18-2,18.64,18.64,0,0,1,.49-2.72,44.65,44.65,0,0,1,2.55-7.18c.46-1.08,1.21-1.59,1.95-1.34.44.15,1,.59.92,1.85,0,.65-.06,1.29-.11,1.94s-.09,1.25-.11,1.87a13.06,13.06,0,0,0,3.34-2.18,11,11,0,0,1,4.2-2.48,2.52,2.52,0,0,1,2,.16,1.46,1.46,0,0,1,.56,1.12,1.55,1.55,0,0,1-.09.71,1.77,1.77,0,0,1,.65,0,1.29,1.29,0,0,1,1.09,1.15,1,1,0,0,1,0,.38,1.46,1.46,0,0,1,1.46.59,1.17,1.17,0,0,1,.16.51H135a1.94,1.94,0,0,1,1.4.41,1.42,1.42,0,0,1,.53,1,2.09,2.09,0,0,1-.79,1.62c-3.2,3.15-10.77,7.12-14.78,8.67h0A4.27,4.27,0,0,1,119.82,109.77Zm1.33-.79h0Zm-.66-15.87c-.19,0-.48.34-.67.8a43.57,43.57,0,0,0-2.49,7,16.21,16.21,0,0,0-.47,2.56,4.57,4.57,0,0,0,.13,1.63c.61,2,1.27,3.1,2.07,3.49a2.34,2.34,0,0,0,1.91-.08h0c4-1.55,11.45-5.52,14.43-8.45.23-.22.53-.55.5-.83a.41.41,0,0,0-.17-.29.94.94,0,0,0-.65-.19,2.35,2.35,0,0,0-.89.37,4.22,4.22,0,0,1-.55.39.5.5,0,0,1-.54-.84l.48-.35a.94.94,0,0,0,.31-.41.18.18,0,0,0,0-.13c-.07-.12-.35-.15-.67-.09a3.38,3.38,0,0,0-1,.39,12.11,12.11,0,0,1-1,.81.52.52,0,0,1-.67-.05.5.5,0,0,1,0-.67,4.18,4.18,0,0,1,1-.89c.18-.18.36-.36.53-.56s.24-.27.23-.39-.13-.18-.27-.21a1.81,1.81,0,0,0-.76.14,12.17,12.17,0,0,0-1.17.51c-.3.22-.62.43-.92.62a9.73,9.73,0,0,0-.85.59.5.5,0,0,1-.65-.76,10.45,10.45,0,0,1,1.88-1.29c.6-.44,1.14-1,1.1-1.41a.48.48,0,0,0-.16-.39c-.11-.08-.41-.18-1.2,0a10.13,10.13,0,0,0-3.8,2.29A11.72,11.72,0,0,1,121.18,99a.48.48,0,0,1-.43-.09.47.47,0,0,1-.19-.38,25.86,25.86,0,0,1,.1-2.65c0-.63.1-1.25.11-1.88s-.08-.83-.24-.88Z",
  fill: "#231f20"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M121.21,98.66a5,5,0,0,1,.09,6.21l.31,0",
  fill: "#fff"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M121.3,105.37a.49.49,0,0,1-.39-.81,4.48,4.48,0,0,0-.08-5.57.51.51,0,0,1,0-.71.49.49,0,0,1,.7,0,5.55,5.55,0,0,1,.49,6.32.48.48,0,0,1,0,.18.5.5,0,0,1-.47.52l-.31,0Z",
  fill: "#231f20"
});

var _ref84 = /*#__PURE__*/React.createElement("rect", {
  x: 121.15,
  y: 81.98,
  width: 81.63,
  height: 23.13,
  rx: 5.61,
  fill: "#fff"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M197.17,105.63H126.76a6.13,6.13,0,0,1-6.12-6.13V87.59a6.13,6.13,0,0,1,6.12-6.13h70.41a6.13,6.13,0,0,1,6.12,6.13V99.5A6.13,6.13,0,0,1,197.17,105.63ZM126.76,82.5a5.09,5.09,0,0,0-5.09,5.09V99.5a5.09,5.09,0,0,0,5.09,5.09h70.41a5.09,5.09,0,0,0,5.09-5.09V87.59a5.09,5.09,0,0,0-5.09-5.09Z",
  fill: "#231f20"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M130.81,96.05a2.51,2.51,0,1,1,2.5-2.51A2.52,2.52,0,0,1,130.81,96.05Zm0-4a1.51,1.51,0,1,0,1.5,1.5A1.51,1.51,0,0,0,130.81,92Z",
  fill: "#d1d3d4"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M139.25,96.05a2.51,2.51,0,1,1,2.5-2.51A2.51,2.51,0,0,1,139.25,96.05Zm0-4a1.51,1.51,0,1,0,1.5,1.5A1.51,1.51,0,0,0,139.25,92Z",
  fill: "#d1d3d4"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M195.12,95.22h-48.5a.5.5,0,0,1-.5-.5V92.37a.5.5,0,0,1,.5-.5h48.5a.5.5,0,0,1,.5.5v2.35A.5.5,0,0,1,195.12,95.22Zm-48-1h47.5V92.87h-47.5Z",
  fill: "#d1d3d4"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M71.88,233.23l-1,7.08s21.86-1.14,21.11-2.84-6.92-3.92-6.92-3.92",
  fill: "#fff"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M70.91,240.81a.49.49,0,0,1-.37-.16.5.5,0,0,1-.13-.4l1-7.09a.49.49,0,0,1,.56-.42.5.5,0,0,1,.43.56l-.89,6.48c9-.49,18.54-1.45,20-2.29-.79-1.09-4.35-2.69-6.53-3.47a.5.5,0,0,1,.34-.94c.65.23,6.39,2.34,7.2,4.19a.72.72,0,0,1,0,.67c-1,1.63-15.37,2.55-21.49,2.87Z",
  fill: "#231f20"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M116.73,106.55s10.83,10.86,16.21,9.33c3.16-.89,17.81-8.24,18-8.54.69-1.18,2.05-5,2.91-6a2.36,2.36,0,0,1,1.28-1c2.78-.49.09,4.52-.63,5.36,2.36-1.47,4.8-2.92,7.3-4.17a1,1,0,0,1,.85-.14.68.68,0,0,1,.25.88,2,2,0,0,1-.67.74l-4.27,3.37a33,33,0,0,1,3.9-2.75c.5-.29,1.89-1.17,2.4-.6.89,1-3.66,4.43-4.44,5a19.26,19.26,0,0,1,4.15-2.91,2,2,0,0,1,1.4-.3c.2.31-.12.69-.42.92L162,108c1.48-1.1,3.12-2.24,5-2.22,0,.31-.24.56-.49.75-4.38,3.43-8.82,7.85-13.36,11.06-6,4.26-12.58,10.18-20.07,10.83-8.89.77-15.4-5.72-21.44-11.37",
  fill: "#fff"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M131.59,129c-8,0-14.18-5.77-19.65-10.89l-.71-.67a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l.72.67c5.91,5.55,12,11.28,20.34,10.56,6-.52,11.39-4.51,16.58-8.37,1.1-.81,2.18-1.62,3.24-2.37a100,100,0,0,0,7.79-6.36c1.7-1.48,3.45-3,5.18-4.39a11.3,11.3,0,0,0-3.5,2,.5.5,0,0,1-.6-.8l2.91-2.25a3.49,3.49,0,0,0-.39.19,19.35,19.35,0,0,0-2,1.17c-.85.74-1.7,1.37-2.13,1.69a.49.49,0,0,1-.68-.09.5.5,0,0,1,0-.68,20.67,20.67,0,0,1,2.15-1.71c1.45-1.26,2.3-2.28,2.25-2.62,0,0,0,0-.09,0a3.81,3.81,0,0,0-1.59.7,29.46,29.46,0,0,0-2.85,1.91l-1.08.85a.5.5,0,0,1-.63-.78c.36-.3.73-.59,1.1-.87l3.18-2.51a1.56,1.56,0,0,0,.52-.54.26.26,0,0,0,0-.24s-.1,0-.41.14c-2.59,1.29-5.12,2.82-7.26,4.14a.5.5,0,0,1-.64-.09.51.51,0,0,1,0-.66c.65-.76,2.09-3.71,1.68-4.44-.09-.15-.36-.13-.59-.09a1.9,1.9,0,0,0-1,.77,22.29,22.29,0,0,0-1.77,3.6c-.43,1-.81,1.89-1.09,2.38-.4.68-15.78,8.06-18.29,8.78-5.58,1.57-16.24-9-16.69-9.47a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0c.11.11,10.7,10.65,15.72,9.21,3-.84,16.53-7.6,17.74-8.39.25-.47.61-1.3,1-2.19a20.3,20.3,0,0,1,1.92-3.85A2.77,2.77,0,0,1,155,99.85a1.39,1.39,0,0,1,1.62.58c.51.88-.06,2.5-.69,3.78,1.74-1,3.65-2.15,5.6-3.13a1.49,1.49,0,0,1,1.3-.14,1.18,1.18,0,0,1,.52,1.44,1.25,1.25,0,0,1,1.25.32.94.94,0,0,1,.23.76,2.2,2.2,0,0,1-.37.9,1.79,1.79,0,0,1,1,0,.45.45,0,0,1,.28.2.89.89,0,0,1,.07.88,5.72,5.72,0,0,1,1.11-.11.5.5,0,0,1,.49.46,1.43,1.43,0,0,1-.68,1.19c-1.82,1.42-3.7,3.06-5.52,4.65-2.56,2.23-5.2,4.54-7.86,6.42-1.06.74-2.13,1.54-3.22,2.36-5.06,3.75-10.78,8-17.1,8.56C132.56,129,132.07,129,131.59,129Z",
  fill: "#231f20"
});

var _ref93 = /*#__PURE__*/React.createElement("polygon", {
  points: "111.94 137.36 124.47 234.48 111.02 234.14 95.29 169.55 86.38 234.3 71.27 233.23 75.75 132.78 111.94 137.36",
  fill: "#231f20"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M106,96.52l22.77,15.09-6.55,17.22S94.19,110.27,94,106,106,96.52,106,96.52Z",
  fill: "#68e1fd"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M115.14,154.65s-.72-29.61-2.84-42.48c-.9-5.46-.56-9.29-2.37-12.24-6.07-9.92-29.72-7-33.16-.08s-4.24,56.6-4.24,56.6Z",
  fill: "#68e1fd"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M111,234.14s-.38,5.86.38,6.81,21.42-.76,20.47-3-8.53-4.19-8.53-4.19",
  fill: "#fff"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M114.09,241.7c-1.67,0-2.83-.13-3.08-.44-.81-1-.58-5.73-.49-7.15a.5.5,0,1,1,1,.06c-.17,2.64-.12,5.77.24,6.41,1.39.5,14-.36,18.49-1.94,1-.35,1.16-.61,1.16-.61-.62-1.4-5.35-3.1-8.19-3.82a.51.51,0,0,1-.37-.61.5.5,0,0,1,.61-.36c.8.2,7.86,2.06,8.87,4.49.13.29.2.86-.7,1.39C129.48,240.4,119.32,241.7,114.09,241.7Zm-2.3-1.06h0Zm-.08-.08Z",
  fill: "#231f20"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M122.17,129.33a.5.5,0,0,1-.26-.08c-.64-.4-15.64-9.94-20.83-15a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0c5.12,4.94,20.52,14.73,20.67,14.83a.48.48,0,0,1,.16.68A.5.5,0,0,1,122.17,129.33Z",
  fill: "#231f20"
});

function SvgSelectRepository(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_160_data_arranging_flatline",
    "data-name": "#160_data_arranging_flatline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectRepository);
export default __webpack_public_path__ + "static/media/SelectRepository.8dccf0b4.svg";
export { ForwardRef as ReactComponent };